<template>
    <div class="field field--checkbox" :class="{'field--disabled': disabled}">
        <div class="field__label field__label--checkbox" v-if="!tos">{{label}}</div>
        <div class="field__label field__label--checkbox field__label--tos" v-else>Am citit si sunt de acord cu <a href="https://nexyo.ro/pages/termeni-si-conditii" class="tos-accept__link" target="_blank">Termenii si Conditiile</a> platformei NEXYO.</div>
        <input type="checkbox" 
            :disabled="disabled"
            class="field__checkbox" 
            :id="id" 
            :checked="isChecked" 
            v-model="isChecked"
            @input="$emit('input', !isChecked)"
        />

        <label class="field__custom-checkbox" :for="id">
            <img src="@/assets/images/icons/checkbox.png">
        </label>
    </div>
</template>

<script>
    export default {
        props: {
            id: {
                type: [Number, String],
                default: 'checkbox-0'
            },
            label: {
                type: String,
                default: ''
            },
            checked: {
                type: Boolean,
                default: false
            },
            tos: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                isChecked: false
            }
        },
        mounted() {
            this.isChecked = this.checked;
        },
        watch: {
            checked: function (newVal) {
                this.isChecked = newVal;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .field {
        width: 100%;
        max-width: 450px;
        margin: 15px auto auto auto;
        position: relative;

        &--checkbox {
            display: flex;
            align-items: center;
        }

        &--disabled {
            opacity: 0.25;
        }

        &__label {
            font-weight: 400;
            font-size: 16px;
            margin-bottom: 5px;
            color: $color-auth-text-main;

            &--checkbox {
                order: 2;
                font-size: 14px;
                margin-bottom: 0;
                margin-left: 10px;
            }

            a{
                color: $color-primary;
                font-weight: 500;
            }

            a:hover{
                text-decoration: underline;
            }
        }

        &__input::placeholder {
            color: $color-placeholder;
        }

        &__input:focus {
            border: 1px solid $color-secondary;
        }

        &__checkbox {
            display: none;
        }

        &__checkbox:checked~&__custom-checkbox {
            background-color: $color-secondary;
            border-color: $color-secondary;

            img {
                display: block;
            }
        }

        &__custom-checkbox {
            position: relative;
            height: 17px;
            width: 17px;
            min-width: 17px;
            border: 1px solid #474C5C;
            border-radius: 3px;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                display: none;
                height: 7px;
                width: 10px;
            }
        }

        &__error {
            color: $color-danger;
            font-size: 12px;
            font-family: "Roboto";
            margin-top: 10px;

        }

        &__text {
            display: flex;
            flex-direction: row;
            font-family: "Roboto";
            font-weight: 400;
            font-size: 12px;
            color: $color-primary;
            margin: 30px auto auto auto;
        }
    }
</style>